import { useQuery } from 'react-query';
import { createFetchAPI } from '../http';

const fetchUobPointRedemptionDetailsViaMerchantConnect = createFetchAPI<
  UobPointRedemptionDetailsRequest,
  UobPointRedemptionDetailsViaMerchantConnectResponse
>();

export const useFetchUobPointRedemptionDetailsViaMerchantConnect = (
  { uob_point_redemption_id }: UobPointRedemptionDetailsRequest,
  enabled: boolean,
) =>
  useQuery<UobPointRedemptionDetailsViaMerchantConnectResponse>(
    [
      'fetchUobPointRedemption',
      { url: `v1/mc_products/${uob_point_redemption_id}` },
    ],
    fetchUobPointRedemptionDetailsViaMerchantConnect,
    { enabled },
  );

type UobPointRedemptionDetailsRequest = {
  uob_point_redemption_id: string;
};

export type UobPointRedemptionDetailsViaMerchantConnectResponse = {
  id: string;
  product_type: string;
  product_details: {
    mdr_percentage: number;
    acquired_by: string;
    outlet_ids: string[];
    remarks: string;
  };
};
